import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../common/utils/customBaseQuery";

export interface GreenAlignTokenResponseType {
	status: string;
    Expires_at: number;
	token?: string;
}

export interface DeviceCodeResponse {
    device_code?: string;
    user_code?: string,
    verification_uri?: string;
    verification_uri_complete?: string;
    expires_in: number;
    interval: number;
    errors?: string;
    gaia_id?: string;
}

const greenAlignApi = createApi({
	reducerPath: "greenAlignApi",
	baseQuery: customBaseQuery({
		baseURL: import.meta.env.VITE_APP_API_PATH!,
	}),
	keepUnusedDataFor: 0,
	endpoints: (builder) => ({
		getSnoopEDeviceCode: builder.query<
			DeviceCodeResponse,
			{}
		>({
			query: () => ({
				url: `green-align/register`,
				method: "POST",
			}),
		}),
		getSnoopEToken: builder.query<
			GreenAlignTokenResponseType,
			string
		>({
			query: (device_code) => ({
				url: `green-align/token/${device_code}`,
				method: "GET",
			}),
		}),
	}),
});

export const { useLazyGetSnoopETokenQuery, useLazyGetSnoopEDeviceCodeQuery } = greenAlignApi;
export default greenAlignApi;


